<template>
  <div class="tip-value">
    <NumAnimate v-for="(item, index) in value.split('')" :key="index" :num="item" />
  </div>
</template>

<script>
import NumAnimate from './NumAnimate'
export default {
  props: {
    value: String
  },
  components: {
    NumAnimate
  }
}
</script>

<style scoped>
.tip-value {
  width: 100%;
  height: 60%;
  /* color: #fff; */
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-weight: bold;
}
</style>
